// extracted by mini-css-extract-plugin
module.exports = {"promoSnackBar":"az_dUc"};